document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initGaleriaProducto();
  initSelectorVariantes();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal, .mt-reveal-stagger');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var obs = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('mt-visible');
          obs.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
  );
  els.forEach(function (el) { obs.observe(el); });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('[data-mt-galeria]');
  if (!galeria) return;
  var principal = galeria.querySelector('[data-mt-imagen-principal]');
  var miniaturas = galeria.querySelectorAll('[data-mt-miniatura]');
  if (!principal || !miniaturas.length) return;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      if (!src) return;
      principal.src = src;
      miniaturas.forEach(function (m) { m.classList.remove('mt-miniatura--activa'); });
      mini.classList.add('mt-miniatura--activa');
    });
  });
}

function initSelectorVariantes() {
  var forms = document.querySelectorAll('[data-mt-form-producto]');
  forms.forEach(function (form) {
    var dataEl = form.querySelector('[data-mt-variantes-json]');
    if (!dataEl) return;
    var variantes;
    try {
      variantes = JSON.parse(dataEl.textContent);
    } catch (e) {
      return;
    }
    var selects = form.querySelectorAll('[data-mt-opcion]');
    var inputId = form.querySelector('[data-mt-input-id]');
    var precioEl = form.querySelector('[data-mt-precio]');
    var precioCompareEl = form.querySelector('[data-mt-precio-compare]');
    var botonComprar = form.querySelector('[data-mt-boton-comprar]');
    if (!selects.length || !inputId) return;

    function variantePorSeleccion() {
      var valores = Array.prototype.map.call(selects, function (s) { return s.value; });
      return variantes.find(function (v) {
        return v.options.every(function (opt, i) { return opt === valores[i]; });
      });
    }

    function actualizar() {
      var v = variantePorSeleccion();
      if (!v) return;
      inputId.value = v.id;
      if (precioEl) precioEl.textContent = v.price_formatted;
      if (precioCompareEl) {
        if (v.compare_at_price_formatted) {
          precioCompareEl.textContent = v.compare_at_price_formatted;
          precioCompareEl.style.display = '';
        } else {
          precioCompareEl.style.display = 'none';
        }
      }
      if (botonComprar) {
        botonComprar.disabled = !v.available;
        botonComprar.textContent = v.available ? botonComprar.getAttribute('data-texto-disponible') : botonComprar.getAttribute('data-texto-agotado');
      }
    }

    selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  });
}
